(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1939],{

/***/ 64387:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/student-services/steps-to-study-abroad",
      function () {
        return __webpack_require__(32604);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 97761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_Unitieup_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73017);
/* harmony import */ var _styles_Unitieup_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_Unitieup_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31555);
/* harmony import */ var _CustomImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45992);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_fetchUtil__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40607);









const TopTieUpsOfKC = ()=>{
    const { 0: topTieUps , 1: setTopTieUps  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        (0,_utils_fetchUtil__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(`${"https://cms-staging.studies-overseas.com"}/top-university-tie-ups`, "GET", {}, "", false).then((res)=>setTopTieUps(res));
    }, []);
    return topTieUps ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        id: "uni-tie-upmain",
        className: (_styles_Unitieup_module_scss__WEBPACK_IMPORTED_MODULE_5___default().uniTieUp),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        id: "unitieuptxt",
                        className: `text-center ${(_styles_Unitieup_module_scss__WEBPACK_IMPORTED_MODULE_5___default().heading)}`,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_styles_Unitieup_module_scss__WEBPACK_IMPORTED_MODULE_5___default().uniDiv),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    children: topTieUps?.title
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: topTieUps?.description
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    id: "unitieupLogo",
                    className: "text-center",
                    children: topTieUps?.images?.length > 0 && topTieUps.images.map((images, index)=>{
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            xl: 3,
                            md: 3,
                            xs: 6,
                            className: `${(_styles_Unitieup_module_scss__WEBPACK_IMPORTED_MODULE_5___default().cols)} ${index > 3 ? (_styles_Unitieup_module_scss__WEBPACK_IMPORTED_MODULE_5___default().borderl0) : ""}`,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_styles_Unitieup_module_scss__WEBPACK_IMPORTED_MODULE_5___default().unidiv),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    src: images?.imageUrl,
                                    alt: images?.imageAltTag,
                                    width: 174,
                                    height: 75
                                })
                            })
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "text-center mt-3",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                        href: "/universities",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            id: "moreUniId",
                            className: (_styles_Unitieup_module_scss__WEBPACK_IMPORTED_MODULE_5___default().viewMore),
                            children: "More Universities"
                        })
                    })
                })
            ]
        })
    }) : null;
};
/* harmony default export */ __webpack_exports__["default"] = (TopTieUpsOfKC);


/***/ }),

/***/ 90211:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_CommonQuestion_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2245);
/* harmony import */ var _styles_CommonQuestion_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_CommonQuestion_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(31555);
/* harmony import */ var react_bootstrap_Accordion__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(54076);
/* harmony import */ var react_bootstrap_Tab__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73192);
/* harmony import */ var react_bootstrap_Nav__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(80957);
/* harmony import */ var _CustomImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45992);










const CommonQuestionsPage = (props)=>{
    const { 0: selectedCategory , 1: setSelectedCategory  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(props.data[0]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setSelectedCategory(props.data[0]);
    }, [
        props.data
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        id: "common-questions-page",
        className: (_styles_CommonQuestion_module_scss__WEBPACK_IMPORTED_MODULE_3___default().commonQue),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: "mb-5",
                        children: "Common Questions"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Tab__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Container */ .Z.Container, {
                    id: "left-tabs-example",
                    defaultActiveKey: props.data[0].name.toLowerCase(),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                lg: 4,
                                md: 4,
                                sm: 12,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_styles_CommonQuestion_module_scss__WEBPACK_IMPORTED_MODULE_3___default().tabNav),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Nav__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        variant: "pills",
                                        className: (_styles_CommonQuestion_module_scss__WEBPACK_IMPORTED_MODULE_3___default().navsett),
                                        children: props.data.map((category)=>{
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Nav__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Item */ .Z.Item, {
                                                className: (_styles_CommonQuestion_module_scss__WEBPACK_IMPORTED_MODULE_3___default().navLink),
                                                onClick: ()=>setSelectedCategory(category),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Nav__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Link */ .Z.Link, {
                                                    eventKey: category.name.toLowerCase(),
                                                    className: `${(_styles_CommonQuestion_module_scss__WEBPACK_IMPORTED_MODULE_3___default().navAnchor)} ${category.name === selectedCategory.name ? (_styles_CommonQuestion_module_scss__WEBPACK_IMPORTED_MODULE_3___default().active) : ""}`,
                                                    children: [
                                                        category.imagePath && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                            src: category.imagePath,
                                                            height: 26,
                                                            width: 26,
                                                            alt: "imagePath"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                                children: category.name
                                                            })
                                                        })
                                                    ]
                                                })
                                            }, category.id);
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                lg: 8,
                                md: 8,
                                sm: 12,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: `${(_styles_CommonQuestion_module_scss__WEBPACK_IMPORTED_MODULE_3___default().tabContent)} ${(_styles_CommonQuestion_module_scss__WEBPACK_IMPORTED_MODULE_3___default().content)}`,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Tab__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Content */ .Z.Content, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Tab__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Pane */ .Z.Pane, {
                                            eventKey: selectedCategory.name.toLowerCase(),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                    children: selectedCategory.name
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Accordion__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                    children: selectedCategory?.questions?.length > 0 && selectedCategory?.questions.map((qna, index)=>{
                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Accordion__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Item */ .Z.Item, {
                                                            eventKey: index.toString(),
                                                            className: (_styles_CommonQuestion_module_scss__WEBPACK_IMPORTED_MODULE_3___default().stuAccordion),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Accordion__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Header */ .Z.Header, {
                                                                    className: (_styles_CommonQuestion_module_scss__WEBPACK_IMPORTED_MODULE_3___default().accoHead),
                                                                    children: qna.question
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Accordion__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Body */ .Z.Body, {
                                                                    className: (_styles_CommonQuestion_module_scss__WEBPACK_IMPORTED_MODULE_3___default().accorBody),
                                                                    children: qna.answer
                                                                })
                                                            ]
                                                        }, index);
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CommonQuestionsPage);


/***/ }),

/***/ 32604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ steps_to_study_abroad; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/MetaTagsComp.tsx
var MetaTagsComp = __webpack_require__(47046);
// EXTERNAL MODULE: ./styles/studentservices.module.scss
var studentservices_module = __webpack_require__(82908);
var studentservices_module_default = /*#__PURE__*/__webpack_require__.n(studentservices_module);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Breadcrumb.js + 1 modules
var Breadcrumb = __webpack_require__(26699);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick.css
var slick = __webpack_require__(98322);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick-theme.css
var slick_theme = __webpack_require__(98745);
// EXTERNAL MODULE: ./components/WebinarEvents.tsx
var WebinarEvents = __webpack_require__(72350);
// EXTERNAL MODULE: ./components/FeaturedBlogs.tsx
var FeaturedBlogs = __webpack_require__(85684);
// EXTERNAL MODULE: ./components/CustomImage.tsx
var CustomImage = __webpack_require__(45992);
// EXTERNAL MODULE: ./components/commonQuestions.tsx
var commonQuestions = __webpack_require__(90211);
// EXTERNAL MODULE: ./components/Testimonial.tsx
var Testimonial = __webpack_require__(537);
// EXTERNAL MODULE: ./components/UniTieUp.tsx
var UniTieUp = __webpack_require__(97761);
// EXTERNAL MODULE: ./components/SeveneasySteps.tsx
var SeveneasySteps = __webpack_require__(36596);
// EXTERNAL MODULE: ./components/kcNewlatestupdates.tsx
var kcNewlatestupdates = __webpack_require__(79465);
// EXTERNAL MODULE: ./utils/helpers.ts + 1 modules
var helpers = __webpack_require__(32866);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./utils/applyCtaButtonProps.ts
var utils_applyCtaButtonProps = __webpack_require__(78409);
// EXTERNAL MODULE: ./utils/b2c/sourceTracking.ts
var sourceTracking = __webpack_require__(3265);
// EXTERNAL MODULE: ./utils/b2c/constants.ts
var constants = __webpack_require__(90017);
;// CONCATENATED MODULE: ./components/ServicesForStudent.tsx























const ServicesStudentPage = (props)=>{
    const router = (0,next_router.useRouter)();
    const sliderRef = (0,react.useRef)(null);
    var settings = {
        dotsClass: (studentservices_module_default()).sliderDots,
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
        arrows: false
    };
    const servicesStudentData = props.pageData;
    const heroToOnboardingEnabled = servicesStudentData?.heroSectionBtn?.toOnboardingEnabled;
    const applyCtaButtonProps = (0,utils_applyCtaButtonProps/* getOnboardingOrFormCtaProps */.J)(router, {
        btnLink: servicesStudentData?.heroSectionBtn?.btnLink,
        formId: servicesStudentData?.heroSectionBtn?.formId || (heroToOnboardingEnabled ? undefined : "main-enquiry-form"),
        toOnboardingEnabled: heroToOnboardingEnabled
    });
    const renderService = (service)=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                    lg: 6,
                    md: 6,
                    xs: 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "servc-studnt",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                            src: service?.newImagePath?.imageUrl,
                            alt: service?.newImagePath?.alt,
                            width: 540,
                            height: 400
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                    lg: 6,
                    md: 6,
                    xs: 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        id: "servc-studnts",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "subHeadStyle",
                                children: service.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "subHeadPara",
                                children: service.description
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                className: "subHeadSub",
                                children: "Offerings"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: "pl-0",
                                children: service?.offerings?.length > 0 && service?.offerings.map((offer, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "subHeadUlLi",
                                        children: offer
                                    }, index))
                            }),
                            renderLinks(service.links)
                        ]
                    })
                })
            ]
        });
    };
    const linkClickHandler = (link)=>(e)=>{
            if (link.href) {
                window.open(link.href);
                return;
            }
            if (props?.pageData?.meta?.jotforms[0]?.jotformid) {
                return;
            }
            if (link?.toOnboardingEnabled) {
                (0,sourceTracking/* persistSourceContext */.jW)({
                    sourceUrl: window.location.href,
                    primarySource: constants/* PRIMARY_SOURCE_B2C_WIDGET */.ov,
                    fifthStepVisible: link?.onBoardingFlow?.nearestOffice ?? true,
                    coachingVisible: link?.onBoardingFlow?.lookingForCoaching ?? true
                });
                window.location.href = "/onboarding?source_url=student-services/steps-to-study-abroad";
            }
        };
    const renderLinks = (links)=>{
        return links.map((link)=>{
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: link.type === "one" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: `subAnchor contBtn ${!link.href ? `btn ${(0,helpers/* isFrappeOrJotFormClass */.gd)(props?.pageData?.meta?.jotforms[0]?.jotformid)}` : ""}`,
                    onClick: linkClickHandler(link),
                    children: link.label
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: link.href,
                    className: (studentservices_module_default()).knowMore,
                    children: link.label
                })
            });
        });
    };
    const enquireNowClickHandler = (e)=>{
        if (applyCtaButtonProps.mode === "onboarding") {
            (0,sourceTracking/* persistSourceContext */.jW)({
                sourceUrl: window.location.href,
                primarySource: constants/* PRIMARY_SOURCE_B2C_WIDGET */.ov,
                fifthStepVisible: servicesStudentData?.heroSectionBtn?.onBoardingFlow?.nearestOffice ?? true,
                coachingVisible: servicesStudentData?.heroSectionBtn?.onBoardingFlow?.lookingForCoaching ?? true
            });
        }
        applyCtaButtonProps.onClick?.(e);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (studentservices_module_default()).studentServicesPage,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (studentservices_module_default()).studentServicesCurve,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (studentservices_module_default()).contentDiv,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                    lg: 6,
                                    md: 6,
                                    xs: 12,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "d-block d-sm-none ",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "d-flex justify-content-center",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumb/* default */.Z, {
                                                        className: (studentservices_module_default()).mobileBreadCrum,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                                                href: "/",
                                                                style: {
                                                                    opacity: 0.5
                                                                },
                                                                children: "Services"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                                                href: "",
                                                                children: "For Students"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                    src: props.pageData.mainImageUrl || "/images/home-page-service-1.svg",
                                                    alt: "home-page-service",
                                                    width: 540,
                                                    height: 400
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (studentservices_module_default()).servContent,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumb/* default */.Z, {
                                                    className: "d-none d-sm-block",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                                            href: "/",
                                                            style: {
                                                                opacity: 0.5
                                                            },
                                                            children: "Services"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                                            href: "",
                                                            children: "For Students"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                    children: props?.pageData?.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: props?.pageData?.description
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    onClick: enquireNowClickHandler,
                                                    className: `${(studentservices_module_default()).enquirebtn} ${`btn ${applyCtaButtonProps.formClassName}`}`,
                                                    children: servicesStudentData?.heroSectionBtn?.label || "Enquire Now"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    lg: 6,
                                    md: 6,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "d-none d-sm-block text-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                            src: props.pageData.newmainImageUrl?.imageUrl || "/images/home-page-service-1.svg",
                                            alt: props.pageData.newmainImageUrl?.alt,
                                            width: 540,
                                            height: 400
                                        })
                                    })
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (studentservices_module_default()).WhyKc,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: "Why KC?"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            children: props?.pageData?.whyKc?.length > 0 && props?.pageData?.whyKc.map((kcBenefit)=>{
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    xl: 4,
                                    md: 4,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "text-center mb-3",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (studentservices_module_default()).img,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                    src: kcBenefit?.imagePath,
                                                    alt: kcBenefit?.ImageAltTag,
                                                    width: 107,
                                                    height: 76
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                children: kcBenefit?.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: kcBenefit?.description
                                            })
                                        ]
                                    })
                                });
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (studentservices_module_default()).studentHelpMainDiv,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "text-center",
                            children: "How do we help students?"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "desktop d-none d-sm-block",
                        children: props?.pageData?.studentServices?.length > 0 && props?.pageData?.studentServices.map((service, index)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (studentservices_module_default()).studentHelp,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (studentservices_module_default()).alignTop,
                                        id: `${index + 1}`
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                            children: (index + 1) % 2 === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                        lg: 6,
                                                        md: 6,
                                                        xs: 12,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                    className: "subHeadStyle",
                                                                    children: service.title
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "subHeadPara",
                                                                    children: service.description
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                                    className: "subHeadSub",
                                                                    children: "Offerings"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                                    className: "pl-0",
                                                                    children: service?.offerings?.length > 0 && service?.offerings.map((offer, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                            className: "subHeadUlLi",
                                                                            children: offer
                                                                        }, index))
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (studentservices_module_default()).linksDiv,
                                                                    children: renderLinks(service.links)
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                        lg: 6,
                                                        md: 6,
                                                        xs: 12,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                src: service?.newImagePath?.imageUrl,
                                                                alt: service?.newImagePath?.alt,
                                                                width: 540,
                                                                height: 400
                                                            })
                                                        })
                                                    })
                                                ]
                                            }) : renderService(service)
                                        })
                                    })
                                ]
                            }, index);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mobile d-block d-sm-none",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                                        ...settings,
                                        ref: sliderRef,
                                        className: (studentservices_module_default()).slider,
                                        children: props?.pageData?.studentServices?.length > 0 && props?.pageData?.studentServices.map((service, index)=>{
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (studentservices_module_default()).studentHelp,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                                        children: renderService(service)
                                                    })
                                                })
                                            });
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (studentservices_module_default()).arrowsClasses,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (studentservices_module_default()).btcircle,
                                                onClick: ()=>sliderRef?.current?.slickPrev(),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                    src: "/new-images/left-arrow.svg",
                                                    height: 17,
                                                    width: 10,
                                                    alt: "left-arrow"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (studentservices_module_default()).btcircle,
                                                onClick: ()=>sliderRef?.current?.slickNext(),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                    src: "/new-images/right-arrow.svg",
                                                    height: 17,
                                                    width: 10,
                                                    alt: "right-arrow"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (studentservices_module_default()).studentServicesWebinarEvent,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WebinarEvents["default"], {
                    headingLevel: 2
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (studentservices_module_default()).sevenBG,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SeveneasySteps/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (studentservices_module_default()).studentTieUpsUni,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UniTieUp["default"], {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (studentservices_module_default()).studentCommonQues,
                children: props?.pageData?.commonQuestions?.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(commonQuestions/* default */.Z, {
                    data: props?.pageData?.commonQuestions
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Testimonial/* default */.Z, {
                title: "What our students say about us?",
                bgColor: "#FFFFFF",
                slug: "student-testimonials?_limit=15&_sort=id:DESC"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (studentservices_module_default()).studentServicesKcUpdates,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(kcNewlatestupdates["default"], {
                    ...props
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (studentservices_module_default()).StudentBlogs,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedBlogs["default"], {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "d-none d-sm-block",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (studentservices_module_default()).studentFooter,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (studentservices_module_default()).session,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    children: "Start your Study Abroad Journey with KC "
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Book a free in person or virtual counselling session with our experts now!"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (studentservices_module_default()).anchor,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "/contact-us",
                                                className: "btn btn-primary",
                                                children: "Contact Us"
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var ServicesForStudent = (ServicesStudentPage);

;// CONCATENATED MODULE: ./pages/student-services/steps-to-study-abroad.tsx




const StudentServices = (props)=>{
    const { meta  } = props?.pageData;
    (0,react.useEffect)(()=>{
        const customStyle = document.documentElement.style;
        customStyle.setProperty("--navbar-color", "#FBBFB6");
        customStyle.setProperty("--navbar-menu-color", "#0E1B2C");
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            meta && /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTagsComp/* MetaTagsComp */.r, {
                ...meta
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ServicesForStudent, {
                ...props
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var steps_to_study_abroad = (StudentServices);


/***/ }),

/***/ 2245:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"commonQue":"CommonQuestion_commonQue__R_Ah2","tabNav":"CommonQuestion_tabNav__2nYOK","navsett":"CommonQuestion_navsett__4TvaO","navLink":"CommonQuestion_navLink__iXJK0","navAnchor":"CommonQuestion_navAnchor__Pr9N3","active":"CommonQuestion_active__6s1cr","tabContent":"CommonQuestion_tabContent__MIzDk","stuAccordion":"CommonQuestion_stuAccordion__Xs394","accordion-button":"CommonQuestion_accordion-button__mdEFg","collapsed":"CommonQuestion_collapsed___93Cd","accoHead":"CommonQuestion_accoHead__HMjDA","accorBody":"CommonQuestion_accorBody__jNnHy"};

/***/ }),

/***/ 73017:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"uniTieUp":"Unitieup_uniTieUp__tb7S6","cols":"Unitieup_cols__vvM4K","borderl0":"Unitieup_borderl0__x9LQV","border0":"Unitieup_border0__pocJi","viewMore":"Unitieup_viewMore__jrZKp","heading":"Unitieup_heading__tu7PU"};

/***/ }),

/***/ 54076:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_Accordion; }
});

// EXTERNAL MODULE: ./node_modules/react-bootstrap/node_modules/classnames/index.js
var classnames = __webpack_require__(44036);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/uncontrollable/lib/esm/index.js + 4 modules
var esm = __webpack_require__(47150);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(76792);
// EXTERNAL MODULE: ./node_modules/dom-helpers/esm/css.js + 5 modules
var css = __webpack_require__(91505);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/Transition.js + 3 modules
var Transition = __webpack_require__(23594);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/transitionEndListener.js
var transitionEndListener = __webpack_require__(93825);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/createChainedFunction.js
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */
function createChainedFunction(...funcs) {
  return funcs.filter(f => f != null).reduce((acc, f) => {
    if (typeof f !== 'function') {
      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
    }

    if (acc === null) return f;
    return function chainedFunction(...args) {
      // @ts-ignore
      acc.apply(this, args); // @ts-ignore

      f.apply(this, args);
    };
  }, null);
}

/* harmony default export */ var esm_createChainedFunction = (createChainedFunction);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/triggerBrowserReflow.js
var triggerBrowserReflow = __webpack_require__(34509);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/TransitionWrapper.js
var TransitionWrapper = __webpack_require__(9337);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Collapse.js









const MARGINS = {
  height: ['marginTop', 'marginBottom'],
  width: ['marginLeft', 'marginRight']
};

function getDefaultDimensionValue(dimension, elem) {
  const offset = `offset${dimension[0].toUpperCase()}${dimension.slice(1)}`;
  const value = elem[offset];
  const margins = MARGINS[dimension];
  return value + // @ts-ignore
  parseInt((0,css/* default */.Z)(elem, margins[0]), 10) + // @ts-ignore
  parseInt((0,css/* default */.Z)(elem, margins[1]), 10);
}

const collapseStyles = {
  [Transition/* EXITED */.Wj]: 'collapse',
  [Transition/* EXITING */.Ix]: 'collapsing',
  [Transition/* ENTERING */.d0]: 'collapsing',
  [Transition/* ENTERED */.cn]: 'collapse show'
};
const defaultProps = {
  in: false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  getDimensionValue: getDefaultDimensionValue
};
const Collapse = /*#__PURE__*/react.forwardRef(({
  onEnter,
  onEntering,
  onEntered,
  onExit,
  onExiting,
  className,
  children,
  dimension = 'height',
  getDimensionValue = getDefaultDimensionValue,
  ...props
}, ref) => {
  /* Compute dimension */
  const computedDimension = typeof dimension === 'function' ? dimension() : dimension;
  /* -- Expanding -- */

  const handleEnter = (0,react.useMemo)(() => esm_createChainedFunction(elem => {
    elem.style[computedDimension] = '0';
  }, onEnter), [computedDimension, onEnter]);
  const handleEntering = (0,react.useMemo)(() => esm_createChainedFunction(elem => {
    const scroll = `scroll${computedDimension[0].toUpperCase()}${computedDimension.slice(1)}`;
    elem.style[computedDimension] = `${elem[scroll]}px`;
  }, onEntering), [computedDimension, onEntering]);
  const handleEntered = (0,react.useMemo)(() => esm_createChainedFunction(elem => {
    elem.style[computedDimension] = null;
  }, onEntered), [computedDimension, onEntered]);
  /* -- Collapsing -- */

  const handleExit = (0,react.useMemo)(() => esm_createChainedFunction(elem => {
    elem.style[computedDimension] = `${getDimensionValue(computedDimension, elem)}px`;
    (0,triggerBrowserReflow/* default */.Z)(elem);
  }, onExit), [onExit, getDimensionValue, computedDimension]);
  const handleExiting = (0,react.useMemo)(() => esm_createChainedFunction(elem => {
    elem.style[computedDimension] = null;
  }, onExiting), [computedDimension, onExiting]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(TransitionWrapper/* default */.Z, {
    ref: ref,
    addEndListener: transitionEndListener/* default */.Z,
    ...props,
    "aria-expanded": props.role ? props.in : null,
    onEnter: handleEnter,
    onEntering: handleEntering,
    onEntered: handleEntered,
    onExit: handleExit,
    onExiting: handleExiting,
    childRef: children.ref,
    children: (state, innerProps) => /*#__PURE__*/react.cloneElement(children, { ...innerProps,
      className: classnames_default()(className, children.props.className, collapseStyles[state], computedDimension === 'width' && 'collapse-horizontal')
    })
  });
}); // @ts-ignore

// @ts-ignore
Collapse.defaultProps = defaultProps;
/* harmony default export */ var esm_Collapse = (Collapse);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionContext.js

function isAccordionItemSelected(activeEventKey, eventKey) {
  return Array.isArray(activeEventKey) ? activeEventKey.includes(eventKey) : activeEventKey === eventKey;
}
const context = /*#__PURE__*/react.createContext({});
context.displayName = 'AccordionContext';
/* harmony default export */ var AccordionContext = (context);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionCollapse.js







const AccordionCollapse = /*#__PURE__*/react.forwardRef(({
  as: Component = 'div',
  bsPrefix,
  className,
  children,
  eventKey,
  ...props
}, ref) => {
  const {
    activeEventKey
  } = (0,react.useContext)(AccordionContext);
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion-collapse');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_Collapse, {
    ref: ref,
    in: isAccordionItemSelected(activeEventKey, eventKey),
    ...props,
    className: classnames_default()(className, bsPrefix),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      children: react.Children.only(children)
    })
  });
});
AccordionCollapse.displayName = 'AccordionCollapse';
/* harmony default export */ var esm_AccordionCollapse = (AccordionCollapse);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionItemContext.js

const AccordionItemContext_context = /*#__PURE__*/react.createContext({
  eventKey: ''
});
AccordionItemContext_context.displayName = 'AccordionItemContext';
/* harmony default export */ var AccordionItemContext = (AccordionItemContext_context);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionBody.js







const AccordionBody = /*#__PURE__*/react.forwardRef(({
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  bsPrefix,
  className,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion-body');
  const {
    eventKey
  } = (0,react.useContext)(AccordionItemContext);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_AccordionCollapse, {
    eventKey: eventKey,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      ref: ref,
      ...props,
      className: classnames_default()(className, bsPrefix)
    })
  });
});
AccordionBody.displayName = 'AccordionBody';
/* harmony default export */ var esm_AccordionBody = (AccordionBody);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionButton.js







function useAccordionButton(eventKey, onClick) {
  const {
    activeEventKey,
    onSelect,
    alwaysOpen
  } = (0,react.useContext)(AccordionContext);
  return e => {
    /*
      Compare the event key in context with the given event key.
      If they are the same, then collapse the component.
    */
    let eventKeyPassed = eventKey === activeEventKey ? null : eventKey;

    if (alwaysOpen) {
      if (Array.isArray(activeEventKey)) {
        if (activeEventKey.includes(eventKey)) {
          eventKeyPassed = activeEventKey.filter(k => k !== eventKey);
        } else {
          eventKeyPassed = [...activeEventKey, eventKey];
        }
      } else {
        // activeEventKey is undefined.
        eventKeyPassed = [eventKey];
      }
    }

    onSelect == null ? void 0 : onSelect(eventKeyPassed, e);
    onClick == null ? void 0 : onClick(e);
  };
}
const AccordionButton = /*#__PURE__*/react.forwardRef(({
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'button',
  bsPrefix,
  className,
  onClick,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion-button');
  const {
    eventKey
  } = (0,react.useContext)(AccordionItemContext);
  const accordionOnClick = useAccordionButton(eventKey, onClick);
  const {
    activeEventKey
  } = (0,react.useContext)(AccordionContext);

  if (Component === 'button') {
    props.type = 'button';
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    onClick: accordionOnClick,
    ...props,
    "aria-expanded": eventKey === activeEventKey,
    className: classnames_default()(className, bsPrefix, !isAccordionItemSelected(activeEventKey, eventKey) && 'collapsed')
  });
});
AccordionButton.displayName = 'AccordionButton';
/* harmony default export */ var esm_AccordionButton = (AccordionButton);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionHeader.js





const AccordionHeader = /*#__PURE__*/react.forwardRef(({
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'h2',
  bsPrefix,
  className,
  children,
  onClick,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion-header');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames_default()(className, bsPrefix),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm_AccordionButton, {
      onClick: onClick,
      children: children
    })
  });
});
AccordionHeader.displayName = 'AccordionHeader';
/* harmony default export */ var esm_AccordionHeader = (AccordionHeader);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionItem.js






const AccordionItem = /*#__PURE__*/react.forwardRef(({
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  bsPrefix,
  className,
  eventKey,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion-item');
  const contextValue = (0,react.useMemo)(() => ({
    eventKey
  }), [eventKey]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AccordionItemContext.Provider, {
    value: contextValue,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      ref: ref,
      ...props,
      className: classnames_default()(className, bsPrefix)
    })
  });
});
AccordionItem.displayName = 'AccordionItem';
/* harmony default export */ var esm_AccordionItem = (AccordionItem);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Accordion.js












const Accordion = /*#__PURE__*/react.forwardRef((props, ref) => {
  const {
    // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div',
    activeKey,
    bsPrefix,
    className,
    onSelect,
    flush,
    alwaysOpen,
    ...controlledProps
  } = (0,esm/* useUncontrolled */.Ch)(props, {
    activeKey: 'onSelect'
  });
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion');
  const contextValue = (0,react.useMemo)(() => ({
    activeEventKey: activeKey,
    onSelect,
    alwaysOpen
  }), [activeKey, onSelect, alwaysOpen]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AccordionContext.Provider, {
    value: contextValue,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      ref: ref,
      ...controlledProps,
      className: classnames_default()(className, prefix, flush && `${prefix}-flush`)
    })
  });
});
Accordion.displayName = 'Accordion';
/* harmony default export */ var esm_Accordion = (Object.assign(Accordion, {
  Button: esm_AccordionButton,
  Collapse: esm_AccordionCollapse,
  Item: esm_AccordionItem,
  Header: esm_AccordionHeader,
  Body: esm_AccordionBody
}));

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6066,9882,3656,4706,5684,9465,2350,3593,1437,9774,2888,179], function() { return __webpack_exec__(64387); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);